import axios from 'axios';
import { message } from 'antd';

// 创建axios实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  timeout: 10000,
});

// 请求拦截器 - 自动添加认证头
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理认证错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token过期或无效，清除本地存储并跳转到登录页
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      message.error('認証の有効期限が切れました。再度ログインしてください。');
      window.location.href = '/login';
    } else if (error.response?.status === 403) {
      message.error('アクセス権限がありません');
    } else if (error.response?.status >= 500) {
      message.error('サーバーエラーが発生しました');
    }
    return Promise.reject(error);
  }
);

export default api;